export function Logo({ className = "h-8 w-8", rounded = "rounded-xl" }) {
  return (
    <span className={`inline-flex items-center justify-center shrink-0 overflow-hidden ${rounded} ${className}`} aria-label="Ninyaa">
      <img src="/brand/ninyaa-logo.png" alt="Ninyaa" className="h-full w-full object-cover" draggable="false" />
    </span>
  );
}

export function LogoFull({ className = "h-8", tone = "dark" }) {
  const color = tone === "light" ? "#0B0F19" : "#FFFFFF";
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} aria-label="Ninyaa">
      <Logo className="h-full aspect-square" />
      <span
        className="font-heading font-extrabold tracking-tight leading-none"
        style={{ color, fontSize: "1.7em" }}
      >
        Ninyaa
      </span>
    </span>
  );
}
